if ( window.wp && window.wp.ajax ) {

    const { registerBlockType } = window.wp.blocks;
    
    const { 
        RichText,
        InspectorControls,
        MediaUpload,
    } = window.wp.editor;
    
    const { 
        PanelBody, 
        IconButton, 
        TextControl,
    } = window.wp.components;

    registerBlockType('custom-gutenberg/card-category', {
        // built-in attributes
        title: 'Card Category',
        description: 'Custom Card Category',
        icon: '',
        category: 'custom-cards',
        example: {},

        // custom attributes
        attributes: {
            link: {
                type: 'string',
                default: '',
            },
            image: {
                type: 'string',
                default: ''
            }, 
            alt: {
                type: 'string',
                default: ''
            },
            title: {
                type: 'string',
                default: ''
            },
            viewMore: {
                type: 'string',
                default: 'View more'
            },
        },

        // built-in functions
        edit({ attributes, setAttributes }) {

            const {
                link,
                image,
                alt,
                title,
                viewMore
            } = attributes;

            // custom functions
            function onLinkChange(link) {
                setAttributes({link: link});
            };

            function onSelectImage(image) {
                setAttributes({image: image.sizes.full.url});
            }

            function onAltChange(alt) {
                setAttributes({alt: alt});
            }

            function onTitleChange(title) {
                setAttributes({title: title});
            }

            function onViewMoreChange(viewMore) {
                setAttributes({viewMore: viewMore});
            }

            return ([
                <InspectorControls style={ { marginBottom: '40px' } }>
                    <PanelBody title={ 'Settings' }>
                        <MediaUpload 
                            onSelect={ onSelectImage }
                            type="image"
                            value={ image } 
                            render={ ( { open } ) => (
                                <IconButton
                                    onClick={ open }
                                    icon="upload"
                                    classNames="editor-media-placeholder__button is-button is-default is-large">
                                    Select Background Image
                                </IconButton>
                            ) } />
                        <br />
                        <p><strong>Alt image:</strong></p>
                        <TextControl value={ alt } onChange={ onAltChange }></TextControl>
                        <br />
                        <p><strong>Enter url: (ex: /en/rentals)</strong></p>
                        <TextControl value={ link } onChange={ onLinkChange }></TextControl>
                        <br />
                        <p><strong>Title</strong></p>
                        <TextControl value={ title } onChange={ onTitleChange }></TextControl>
                        <br />
                        <p><strong>Link</strong></p>
                        <TextControl value={ viewMore } onChange={ onViewMoreChange }></TextControl>

                    </PanelBody>
                </InspectorControls>
                ,
                <a class="card border-0 card-category position-relative">
                    <div class="card-img-top">
                        <img class="cover-image h-100 w-100" src={ image } alt={ alt } />
                        <div class="view-more headings-font-family">
                            <RichText 
                            key="editable" 
                            tagName="span"
                            classList="text"
                            placeholder="View more" 
                            value={ viewMore }
                            onChange={ onViewMoreChange } /><i class="las la-arrow-right ms-2"></i>
                        </div>
                    </div>
                    <div class="card-body bg-primary bg-opacity-75 position-absolute bottom-0 start-0 end-0">
                        <RichText 
                        key="editable" 
                        tagName="h4"
                        classList="h5 text-white mb-0 text-center text-uppercase"
                        placeholder="TITLE" 
                        value={ title }
                        onChange={ onTitleChange } />
                    </div>
                </a>
            ]
            );
        },

        save({ attributes }) {

            const {
                link,
                image,
                alt,
                title,
                viewMore
            } = attributes;

            return (
                <a href={ link } class="card border-0 card-category position-relative">
                    <div class="card-img-top">
                        <img class="lozad cover-image h-100 w-100" data-src={ image } alt={ alt } />
                        <div class="view-more headings-font-family">
                            <span class="text">{ viewMore }</span><i class="las la-arrow-right ms-2"></i>
                        </div>
                    </div>
                    <div class="card-body bg-primary bg-opacity-75 position-absolute bottom-0 start-0 end-0">
                        <h4 class="h5 text-white mb-0 text-center text-uppercase">{ title }</h4>
                    </div>
                </a>
            );
        },
    });
}